export const usePrice = () => {
    const getPrice = (value: number, billedPerDay = false) => {
        if (billedPerDay) {
            return value * window.RESERVATION_STORE.trip_duration;
        }

        return value;
    };

    const formatPrice = (value: number) => `${value.toFixed(2).replace('.', ',')} €`;

    const formattedPrice = (value: number | string, billedPerDay = false) => {
        if (!['number', 'string'].includes(typeof value)) {
            return '';
        }

        const numberValue = typeof value === 'number' ? value : parseFloat(value);

        return formatPrice(getPrice(numberValue, billedPerDay));
    };

    return {
        formatPrice,
        getPrice,
        formattedPrice,
    };
};
